/* 孫吳傳・第 5 章：牛渚（195 年）
 * 長江由北往南流過地圖中間。西岸是孫策渡江前的營地（歷陽），東岸是劉繇的牛渚營，營中有邸閣（糧倉）。
 * 東岸只有中段一片淺灘能靠岸，岸上有弓手。 */
export const BEACH = [4500, 2500], GRANARY = [6100, 2250];
export default {
  id: 'niuzhu', name: '牛渚', W: 8000, H: 5000, seed: 1950,
  bases: [[1300, 2500], [6400, 2400]], // 歷陽（孫策營）、牛渚營
  rivers: [{ pts: [[3500, -100], [3700, 1200], [3550, 2500], [3750, 3800], [3600, 5100]], hw: 760, fords: [] }],
  roads: [
    { pts: [[1300, 2500], [2400, 2500], [2700, 2500]], w: 150 }, // 西岸：營地到江邊
    { pts: [[4700, 2500], [5400, 2400], [6100, 2300], [6900, 2400]], w: 150 }, // 東岸：淺灘到牛渚營
    { pts: [[5400, 2400], [5700, 1400], [6200, 800]], w: 90 },
  ],
  rocks: [[5200, 1200, 360, 180], [5400, 3800, 400, 200], [7300, 1300, 300, 160], [1200, 1200, 300, 160], [1300, 3900, 340, 180]],
  woods: 0.4,
  sight: 0.8,
  clearings: [[GRANARY[0], GRANARY[1], 520], [BEACH[0] + 300, BEACH[1], 380], [2500, 2500, 300]],
  marsh: [[BEACH[0] - 200, BEACH[1], 260, 220]], // 淺灘：船能划上來、人也能走
  shops: [[1500, 2350]],
  tents: [{ x: 1300, y: 2500, n: 6, r: 380, col: '#b8433a', flag: '孫' }, { x: 6400, y: 2400, n: 11, r: 560, chief: true, col: '#5d6a78', flag: '劉' }],
  grass: [[5000, 2000, 220, 100], [5000, 3000, 220, 100], [5900, 3100, 240, 110]],
};
